module.exports = __webpack_public_path__ + "static/media/huawei_en.d66b755b.png";